<template>
  <el-footer class="footer">
    <div class="container">
      <div class="footer-content">
        <div class="footer-section">
          <h3>关于向远物流</h3>
          <p>武汉向远物流有限公司是一家专业提供汽车托运服务的物流公司，致力于为客户提供安全、高效、便捷的汽车运输服务。</p>
        </div>
        <div class="footer-section">
          <h3>服务项目</h3>
          <ul>
            <li><router-link to="/services">私家车托运</router-link></li>
            <li><router-link to="/services">新车托运</router-link></li>
            <li><router-link to="/services">豪车托运</router-link></li>
            <li><router-link to="/services">展车托运</router-link></li>
          </ul>
        </div>
        <div class="footer-section">
          <h3>快速链接</h3>
          <ul>
            <li><router-link to="/process">运车流程</router-link></li>
            <li><router-link to="/cases">运车案例</router-link></li>
            <li><router-link to="/news">新闻资讯</router-link></li>
            <li><router-link to="/contact">联系我们</router-link></li>
          </ul>
        </div>
        <div class="footer-section">
          <h3>联系方式</h3>
          <p>电话：{{ contact.phone || '400-629-6665' }}</p>
          <p>邮箱：{{ contact.email || '2494330680@qq.com' }}</p>
          <p>地址：{{ contact.address || '武汉市汉南区通江二路哈工大机器人武汉产业基地研发楼' }}</p>
        </div>
      </div>
      <div class="footer-bottom">
        <p>&copy; 2024 武汉向远物流有限公司 版权所有</p>
      </div>
    </div>
  </el-footer>
</template>

<script>
import { getContact } from '../api'

export default {
  name: 'Footer',
  data() {
    return {
      contact: {}
    }
  },
  async mounted() {
    try {
      const res = await getContact()
      if (res.data) {
        this.contact = res.data
      }
    } catch (error) {
      console.error('加载联系方式失败', error)
    }
  }
}
</script>

<style scoped>
.footer {
  background: #2c3e50;
  color: #fff;
  padding: 40px 0 20px;
  margin-top: auto; /* 使用 auto 让 footer 自动推到底部 */
  width: 100%;
  flex-shrink: 0; /* 防止 footer 被压缩 */
  height: auto !important; /* 覆盖 Element UI 默认的 60px 高度 */
  min-height: auto !important; /* 确保最小高度也是 auto */
}

/* 使用深度选择器覆盖 Element UI 的内联样式 */
.footer >>> .el-footer {
  height: auto !important;
  min-height: auto !important;
}

.footer-content {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 40px;
  margin-bottom: 30px;
}

.footer-section h3 {
  font-size: 18px;
  margin-bottom: 20px;
  color: #409EFF;
}

.footer-section p {
  line-height: 1.8;
  color: #ccc;
  font-size: 14px;
}

.footer-section ul {
  list-style: none;
  padding: 0;
}

.footer-section ul li {
  margin-bottom: 10px;
}

.footer-section ul li a {
  color: #ccc;
  text-decoration: none;
  transition: color 0.3s;
}

.footer-section ul li a:hover {
  color: #409EFF;
}

.footer-bottom {
  text-align: center;
  padding-top: 20px;
  border-top: 1px solid #34495e;
  color: #999;
  font-size: 14px;
}

@media (max-width: 768px) {
  .footer {
    padding: 30px 0 15px;
  }

  .footer-content {
    grid-template-columns: 1fr;
    gap: 30px;
  }

  .footer-section {
    text-align: center;
  }

  .footer-section h3 {
    font-size: 16px;
    margin-bottom: 15px;
  }

  .footer-section p {
    font-size: 13px;
    line-height: 1.6;
  }

  .footer-bottom {
    padding-top: 15px;
    font-size: 12px;
  }
}

@media (max-width: 480px) {
  .footer {
    padding: 20px 0 10px;
  }

  .footer-content {
    gap: 20px;
  }

  .footer-section h3 {
    font-size: 14px;
    margin-bottom: 10px;
  }

  .footer-section p,
  .footer-section ul li {
    font-size: 12px;
  }
}
</style>

